// Very simple event listener stuff
export default class Events {
  constructor() {
    this._events = {};
  }

  // Check if a listener is set
  containsListener(name) {
    return Boolean(this._events[name] && this._events[name].length);
  }

  // Bind a new event to this object
  on(name, callback) {
    if (!this._events[name]) {
      this._events[name] = [];
    }
    this._events[name].push(callback);
  }

  // Bind a new event to this object, that
  // will only be emitted once (autoremove itself)
  once(name, callback) {
    function removeCallback() {
      this.off(name, callback);
      this.off(name, removeCallback);
    }

    if (!this._events[name]) {
      this._events[name] = [];
    }
    this._events[name].push(callback);
    this._events[name].push(removeCallback);
  }

  // Remove a specific event or all event callbacks.
  off(name, callback = false) {
    if (!this._events[name]) {
      return;
    }

    // None given? Just remove them all.
    if (!callback) {
      this._events[name] = [];

      return;
    }

    // Remove the callback from the event list
    this._events[name] = this._events[name].filter((cb) => cb !== callback);
  }

  // Emit a custom event on this object
  emit(name, data) {
    let returnedFalse = false;

    // No event and no catch-all
    if (!this._events[name] && !this._events['*']) {
      return true;
    }

    // It has one or more events, call them.
    if (this._events[name]) {
      this._events[name].forEach((callback) => {
        const result = callback.call(this, data);

        if (result === false) {
          returnedFalse = true;
        }
      });
    }

    // Alright, now try catch-alls too
    if (!this._events['*']) {
      return !returnedFalse;
    }

    for (const index in this._events['*']) {
      const result = this._events['*'][index].call(this, data, name);

      if (result === false) {
        returnedFalse = true;
      }
    }

    return !returnedFalse;
  }
}
